import '@/app/global.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/swiper-bundle.css';

import { createGlobalStyle, css } from 'styled-components';

import { theme } from '@/components/features/theme/theme';
import { globalStyleBody } from '@/styles/global/globalStyleBody';
import { globalStylesFontFace } from '@/styles/global/globalStyleFontFace';
import { globalStyleForm } from '@/styles/global/globalStyleForm';
import { globalStyleGap } from '@/styles/global/globalStyleGap';
import { globalStyleTypographyColor } from '@/styles/global/globalStyleTypographyColor';

function createCSS() {
	let styles = '';

	for (let i = 2; i < 20; i += 1) {
		styles += `
        .anim-active.fade-up:nth-child(${i}) {
          transition-delay: ${i * 0.12}s;
        }
     `;
	}

	for (let a = 2; a < 100; a += 1) {
		styles += `
        .anim-active.fade-right span:nth-child(${a}) {
          transition-delay: ${a * 0.03}s;
        }
     `;
	}

	return css`
		${styles}
	`;
}

export default createGlobalStyle`

    ${createCSS()}
            // ${globalStylesFontFace}
    ${globalStyleBody}
    ${globalStyleTypographyColor}
    ${globalStyleGap}
    ${globalStyleForm}
    i {
        font-family: "PP Migra Italic", serif;
    }

    //common overlay and tint
    .overlay {
        position: fixed;
        height: 100vh;
        width: 100%;
        //background-color: rgba(0,0,0,0.5);
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 9;
        display: none;

        &.show {
            display: block;
        }
    }


    //preloader

    .content-loader {
        position: absolute;
        height: 70%;
        width: 70%;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        justify-content: center;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
    }


    .loading-before-submit {
        position: fixed;
        height: 100vh;
        width: 100%;
        bottom: 0;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.65);
        z-index: 9;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            height: 40px;
        }
    }


    //google map style
    .info-window {
        max-width: 200px;
    }

    .gm-style-iw {
        border-radius: 0 !important;
    }

    .map-info__img {
        img {
            height: 100px;
            margin-bottom: 12px;
            object-fit: cover;
        }
    }

    .map-info__content {
        h4 {
            font-size: 20px;
        }

        p {
            margin-bottom: 5px;
        }
    }

    .gm-style-iw {
        transform: translate3d(0%, -10%, 0) !important;
        max-height: 500px !important;
    }

    .gm-style-iw-chr {
        display: none;
    }

    .gm-style-iw-d {
        overflow: hidden !important;
        max-height: 500px !important;
        height: 100px;
    }


    //swipper slider

    .swiper-pagination-bullet {
        outline: none;
    }

    .swiper-slide {
        height: auto;
    }

    .slick-slide {
        div {
            outline: none !important
        }
    }

    .slick-slide {
        -webkit-transform: translate3d(0, 0, 0);
    }


    .hover {
        position: relative;
        overflow: hidden;

        span {
            z-index: 2;
        }

        &:after {
            content: '';
            position: absolute;
            height: 0;
            width: 0;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            background-color: ${theme.colors.hover};
            transition: all .5s ease;
            border-radius: 19px;
        }

        &:hover {
            &:after {
                height: 100%;
                width: 100%;
            }
        }
    }

    .modal-backdrop {
        background-color: rgb(34 31 31 / 90%);
        min-width: 100%;
        //z-index: 9999;

        &.show {
            opacity: 1;
        }
    }


    //menu fixed
    .scroll-down .menu-desktop {
        transform: translate3d(0, -100%, 0);
    }

    .scroll-up .menu-desktop {
        background-color: #fff;

        .menu-desktop__hamburger__lines {
            &__inner .line {
                background-color: #191818;
            }

            p {
                color: #191818;
            }
        }

        .menu-desktop__hamburger .controller svg {
            path {
                fill: #191818;
            }

            line {
                stroke: #191818;
            }
        }

        .dc-btn a {
            color: #191818;

            &:hover {
                color: #191818 !important;
            }

            &:after, &:before {
                box-shadow: 0 0 0 1px #191818;
            }
        }
    }


    .Toastify__toast-container {
        z-index: 99999999;
    }


    //------------------------animation
    .split-parent {
        overflow: hidden;
    }

    .split-child {
        overflow: hidden;
    }

    .reveal {
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        img {
            transform-origin: left;
        }

        .global-image {
            background: transparent;
        }
    }


    .cursor.-hidden:before {
        transform: scale(0.2) !important;
    }

    .cursor {
        display: block !important;
        visibility: visible !important;

        &.-hidden {
            display: block !important;
            visibility: visible !important;
            @media(max-width: 767px){
                display: none !important;
                visibility: hidden !important;
            }
        }

        @media(max-width: 767px){
            display: none !important;
            visibility: hidden !important;
        }
    }


    .c-scrollbar {
        z-index: 9999;
    }
`;
